import { Media, MediaContextProvider } from '../Media'
// import type { AwardsModuleAwards } from '../../../types/components'
import Desktop from './Desktop'
import Phone from './Phone'
import Tablet from './Tablet'

const ModuleAwardsPage = ({
  moduleProps
}: {
  moduleProps: any
}) => {
  return (
    <MediaContextProvider>
      <Media lessThan='md'>
        <Phone {...moduleProps} />
      </Media>
      <Media between={['md', 'lg']}>
        <Tablet {...moduleProps} />
      </Media>
      <Media greaterThanOrEqual='lg'>
        <Desktop {...moduleProps} />
      </Media>
    </MediaContextProvider>
  )
}

export default ModuleAwardsPage
